// extracted by mini-css-extract-plugin
export default {"text":"prepare-horoscope_text__oO6hb"};